import { Point } from '@angular/cdk/drag-drop/typings/drag-ref';
import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	HostBinding,
	HostListener,
	OnInit,
	Output,
	ViewChild
} from '@angular/core';
import { distance, getInsertPointBetweenCircleAndLine, pointInCicle } from './geometric';

type DargType = 'handle' | 'mask' | 'outside';
export interface MoveEvent {
	startDragPoint: Point;
}
@Component({
	selector: 'common-portrait-mask',
	templateUrl: './portrait-mask.component.html',
	styleUrls: ['./portrait-mask.component.scss']
})
export class PortraitMaskComponent implements OnInit, AfterViewInit {
	@HostBinding('class.portrait-mask') hostClass = true;
	cx = 100;
	cy = 100;
	r = 50;
	maxR: number;
	svgWidth: number; // svg åæ çæ»å®½åº¦
	svgHeight: number;
	handleX = 150;
	handleY = 100;
	handleR = 6;
	cursor = 'grab';
	maskDistanceOffset: Point; // é¼ æ ç¹å»ä½ç½®ä¸åå¿çåç§»
	handleDistanceOffset: Point;
	startDragPoint: Point; // å¼å§æå¨çç¹ï¼å±å¹åæ 
	dragType: DargType;
	@Output() startDrag = new EventEmitter<MouseEvent>();
	@Output() dragging = new EventEmitter<Point>();
	@Output() maskChange = new EventEmitter<ClientRect>();
	@ViewChild('svg', { static: true }) svg: ElementRef;
	@ViewChild('handle', { static: true }) handle: ElementRef;
	@ViewChild('maskCicle', { static: true }) maskCicle: ElementRef;
	constructor(private elRef: ElementRef<HTMLElement>) {
		this.mouseDown = this.mouseDown.bind(this);
		this.mouseUp = this.mouseUp.bind(this);
		this.move = this.move.bind(this);
	}
	toScreenPoint(x, y): Point {
		const pt = this.svg.nativeElement.createSVGPoint();
		pt.x = x;
		pt.y = y;
		return pt.matrixTransform(this.svg.nativeElement.getScreenCTM());
	}
	// å°ä¸ä¸ªè·ç¦»è½¬æ¢æå±å¹å°ºå¯¸
	toScreenDistance(val: number): number {
		const p1 = this.toScreenPoint(0, 0);
		const p2 = this.toScreenPoint(val, 0);
		return p2.x - p1.x;
	}
	toSVGPoint(x, y): Point {
		const pt = this.svg.nativeElement.createSVGPoint();
		pt.x = x;
		pt.y = y;
		return pt.matrixTransform(this.svg.nativeElement.getScreenCTM().inverse());
	}
	// è·åhandleçåéçåå¿åæ  svg
	getLimitHandleCenterPostion(mousePoint: Point): Point {
		// æ ¹æ®mouse pointæ¿å°å¯¹åºçåå¿ä½ç½®
		const point = { x: mousePoint.x - this.handleDistanceOffset.x, y: mousePoint.y - this.handleDistanceOffset.y };
		// Create an SVGPoint for future math
		let r = distance(point.x, point.y, this.cx, this.cy);
		if (r <= this.maxR) {
			return point;
		}
		r = this.maxR;
		const arr = getInsertPointBetweenCircleAndLine(this.cx, this.cy, point.x, point.y, this.cx, this.cy, r);

		const d1 = distance(point.x, point.y, arr[0].x, arr[0].y);
		const d2 = distance(point.x, point.y, arr[1].x, arr[1].y);
		if (d1 < d2) {
			return arr[0];
		} else {
			return arr[1];
		}
	}

	// tslint:disable-next-line: quotemark
	@HostListener('mousedown', ['$event'])
	mouseDown(event: MouseEvent) {
		if (event.button !== 0) {
			return;
		}
		const p = this.toSVGPoint(event.x, event.y);
		this.handleDistanceOffset = { x: p.x - this.handleX, y: p.y - this.handleY };
		this.maskDistanceOffset = { x: p.x - this.cx, y: p.y - this.cy };
		this.startDragPoint = { x: event.x, y: event.y };

		if (pointInCicle(p.x, p.y, this.handleX, this.handleY, this.handleR)) {
			this.dragType = 'handle';
		} else if (pointInCicle(p.x, p.y, this.cx, this.cy, this.r)) {
			this.dragType = 'mask';
		} else {
			this.dragType = 'outside';
			this.startDrag.emit(event);
		}
		window.addEventListener('mousemove', this.move, false);
		window.addEventListener('mouseup', this.mouseUp, false);
		event.stopPropagation();
	}
	ngOnInit() {
		this.calcSize();
	}
	emitMaskRect() {
		const p1 = this.toScreenPoint(this.cx - this.r, this.cy - this.r);
		const p2 = this.toScreenPoint(this.cx + this.r, this.cy + this.r);
		this.maskChange.emit({
			left: p1.x,
			top: p1.y,
			right: p2.x,
			bottom: p2.y,
			width: p2.x - p1.x,
			height: p2.y - p1.y
		});
	}
	ngAfterViewInit() {
		this.emitMaskRect();
	}
	move(event: MouseEvent) {
		switch (this.dragType) {
			case 'handle': {
				const p = this.getLimitHandleCenterPostion(this.toSVGPoint(event.x, event.y));
				this.handleX = p.x;
				this.handleY = p.y;
				this.r = distance(this.handleX, this.handleY, this.cx, this.cy);
				this.emitMaskRect();
				break;
			}
			case 'mask':
				{
					const p = this.toSVGPoint(event.x, event.y);
					p.x = Math.max(0, Math.min(this.svgWidth, p.x));
					p.y = Math.max(0, Math.min(this.svgHeight, p.y));
					this.cx = p.x - this.maskDistanceOffset.x;
					this.cy = p.y - this.maskDistanceOffset.y;
					this.handleX = p.x - this.handleDistanceOffset.x;
					this.handleY = p.y - this.handleDistanceOffset.y;
					this.emitMaskRect();
				}
				break;
			case 'outside':
				this.dragging.emit({ x: event.x, y: event.y });

				break;
			default:
				break;
		}
		event.stopPropagation();
		event.preventDefault();
	}
	mouseUp(event: MouseEvent) {
		window.removeEventListener('mousemove', this.move, false);
		window.removeEventListener('mouseup', this.mouseUp, false);
	}
	// éç½®å°ä¸­å¿ç¹ï¼åå¾ä¸ºæå¤§
	reset() {
		this.calcSize();

		this.emitMaskRect();
	}

	private calcSize() {
		const rect = this.elRef.nativeElement.getBoundingClientRect();
		const p = this.toSVGPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
		const p1 = this.toSVGPoint(rect.left, rect.top);
		const p2 = this.toSVGPoint(rect.right, rect.bottom);
		this.cx = p.x;
		this.cy = p.y;
		this.maxR = this.r = (p2.x - p1.x) / 2;
		this.svgWidth = p2.x - p1.x;
		this.svgHeight = p2.y - p1.y;
		this.handleX = this.cx + this.r;
		this.handleY = this.cy;
	}
}
